var _defs, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRisk = function SvgRisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".risk_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 23.501v-10M.5 15.5h7a3 3 0 0 1 3 3h6a3 3 0 0 1 3 3H.5ZM10.5 18.501h-3",
    className: "risk_svg__a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.394,
    cy: 8.495,
    r: 1.786,
    className: "risk_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.9 1.623.524 1.72a1.177 1.177 0 0 0 1.39.807l1.744-.4a1.585 1.585 0 0 1 1.512 2.623l-1.22 1.316a1.188 1.188 0 0 0 0 1.613l1.22 1.316a1.585 1.585 0 0 1-1.509 2.627l-1.744-.4a1.176 1.176 0 0 0-1.39.806l-.527 1.715a1.575 1.575 0 0 1-3.018 0l-.524-1.719a1.175 1.175 0 0 0-1.39-.806l-1.744.4a1.585 1.585 0 0 1-1.509-2.627L10.938 9.3a1.188 1.188 0 0 0 0-1.613l-1.22-1.314a1.585 1.585 0 0 1 1.509-2.627l1.744.4a1.176 1.176 0 0 0 1.39-.807l.524-1.72a1.576 1.576 0 0 1 3.015.004",
    className: "risk_svg__a"
  })));
};
export default SvgRisk;